import React, { useState } from 'react';
import css from './HeroSection.module.css';
import planningPortalLogo from '../../../../assets/PlanningPortalSVG.svg';
import heroBg from '../../../../assets/Leadflow-landing-page.png';
import { apiBaseUrl } from '../../../../util/api';
import { LEADFLOW_TALK_TO_SALES_CALENDLY_URL } from '../../../../util/enums';
import FreeviewSignupModal from '../FreeviewSignupModal/FreeviewSignupModal';

const HeroSection = ({ currentUser }) => {
  const [activeTab, setActiveTab] = useState('freeview'); // 'freeview' | 'sales'
  const [showModal, setShowModal] = useState(false);
  const [isGeneratingToken, setIsGeneratingToken] = useState(false);

  const isAuthenticated = Boolean(currentUser?.id?.uuid);
  const isLeadflowAccessProvided =
    currentUser?.attributes?.profile?.publicData?.isLeadflowAccessProvided;

  const handleFreeviewClick = async () => {
    if (isAuthenticated && isLeadflowAccessProvided) {
      // Already has LeadFlow access — SSO directly
      try {
        setIsGeneratingToken(true);
        const apiUrl = `${apiBaseUrl()}/api/leadflow/generate-sso-token`;
        const response = await fetch(apiUrl, {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({}),
        });
        const data = await response.json();
        if (data.success && data.data.redirectUrl && typeof window !== 'undefined') {
          window.open(data.data.redirectUrl, '_blank');
        }
      } catch (err) {
        console.error('SSO error:', err);
      } finally {
        setIsGeneratingToken(false);
      }
    } else {
      setShowModal(true);
    }
  };

  const handleTalkToSales = () => {
    if (typeof window !== 'undefined') {
      window.open(LEADFLOW_TALK_TO_SALES_CALENDLY_URL, '_blank');
    }
  };

  return (
    <section className={css.hero}>
      <img src={heroBg} alt="" className={css.bgImage} />
      <div className={css.overlay} />
      <div className={css.inner}>
        <div className={css.dataProvider}>
          <span className={css.dataText}>In collaboration with</span>
          <img src={planningPortalLogo} alt="Planning Portal" className={css.dataLogo} />
          <span className={css.dataPortalName}>PlanningPortal</span>
        </div>

        <h1 className={css.headline}>
          See <span className={css.highlight}>live planning</span> projects in your area
          <span className={css.subHeadline}>…before your competitors do</span>
        </h1>

        <p className={css.description}>
          Access early-stage construction opportunities up to 8 weeks before they hit the market
        </p>

        {isAuthenticated && isLeadflowAccessProvided ? (
          <>
            <button
              className={css.ctaButton}
              onClick={handleFreeviewClick}
              disabled={isGeneratingToken}
            >
              {isGeneratingToken ? 'Connecting…' : 'Access live projects →'}
            </button>
            <p className={css.noCreditCard}>
              <svg width="12" height="14" viewBox="0 0 24 24" fill="white" style={{ marginRight: 5, verticalAlign: 'middle' }}>
                <path d="M18 10h-1V7A5 5 0 0 0 7 7v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zm-6 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm3-7H9V7a3 3 0 0 1 6 0v3z"/>
              </svg>
              No credit card required, instant access
            </p>
          </>
        ) : (
          <>
            {/* Slider toggle */}
            <div className={css.sliderToggle}>
              <button
                className={`${css.sliderOption} ${activeTab === 'freeview' ? css.sliderActive : ''}`}
                onClick={() => setActiveTab('freeview')}
              >
                Freeview of live projects
              </button>
              <button
                className={`${css.sliderOption} ${activeTab === 'sales' ? css.sliderActive : ''}`}
                onClick={() => setActiveTab('sales')}
              >
                Talk to sales
              </button>
            </div>

            {activeTab === 'freeview' ? (
              <>
                <button className={css.ctaButton} onClick={handleFreeviewClick}>
                  View live projects free →
                </button>
                <p className={css.noCreditCard}>
                  <svg width="12" height="14" viewBox="0 0 24 24" fill="white" style={{ marginRight: 5, verticalAlign: 'middle' }}>
                    <path d="M18 10h-1V7A5 5 0 0 0 7 7v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zm-6 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm3-7H9V7a3 3 0 0 1 6 0v3z"/>
                  </svg>
                  No credit card required, instant access
                </p>
              </>
            ) : (
              <>
                <button className={css.ctaButton} onClick={handleTalkToSales}>
                  Book a free call →
                </button>
                <p className={css.noCreditCard}>
                  Full access · Dedicated support · Regional targeting
                </p>
              </>
            )}
          </>
        )}
      </div>

      {showModal && <FreeviewSignupModal onClose={() => setShowModal(false)} />}
    </section>
  );
};

export default HeroSection;
